import { defineStore } from 'pinia';
import { useHttpStore } from './http.store';
import { useNotification } from '@kyvg/vue3-notification';

const localUrl = "companies";
let inited = false;

export const useCompanyStore = defineStore('companies', {
    state: () => ({
        items: [],
        selectedId: null,
    }),
    actions: {
        async init(forced = false) {
            if (!inited || forced) {
                await this.get();
            }
            inited = this.items.length > 0;
            return this.items.length;
        },
        async get() {
            const httpStore = useHttpStore();
            const resp = await httpStore.get(localUrl);
            if (resp) {
                this.items = [].concat(resp);
            }
            return resp;
        },
        select(id) {
            this.selectedId = id;
        },
        async create(data) {
            const httpStore = useHttpStore();
            const resp = await httpStore.post(localUrl, data);
            if (resp) {
                this.items.push(resp);
                return resp;
            }
            return null;
        },
        async update(id, data) {
            const httpStore = useHttpStore();
            const resp = await httpStore.patch(`${localUrl}/${id}`, data);
            if (resp) {
                const company = this.items.find(c => c.id === id);
                if (company) Object.assign(company, resp);
                return true;
            }
            return false;
        },
        async delete(id) {
            const httpStore = useHttpStore();
            const resp = await httpStore.del(`${localUrl}/${id}`);
            if (resp !== null) {
                this.items = this.items.filter(c => c.id !== id);
                if (this.selectedId === id) this.selectedId = null;
                return true;
            }
            return false;
        },
    },
});
